import { render, staticRenderFns } from "./CurrencyColumn.vue?vue&type=template&id=ec7341a2&"
import script from "./CurrencyColumn.vue?vue&type=script&lang=js&"
export * from "./CurrencyColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports